var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-list"},[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"show-page":false,"refresh-method":_vm.refresh,"default-search-key":"obj_name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }